import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import posed from "react-pose";

export const SHADOW_PADDING = 16;

export const Outer = styled(
  posed.div({
    enter: {
      opacity: 1,
      height: "auto",
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 15
      }
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20
      }
    }
  })
)`
  overflow: hidden;
  padding: ${SHADOW_PADDING}px;
  padding-top: 0px;
  box-sizing: border-box;
`;

export const selectMenuStyle = css<{ dashed?: boolean }>`
  box-sizing: border-box;
  overflow: hidden;
  padding: ${select.space(0)} 0px;
  background-color: #ffffff;
  ${p =>
    p.dashed
      ? css`
          border: 1px dashed ${select.color(["grey", 5])};
        `
      : css`
          border: 1px solid ${select.color(["grey", 3])};
        `}
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow: auto;
`;

const SelectMenuBase = styled.div<{ dashed?: boolean }>`
  ${selectMenuStyle}
`;

type Props = {
  children?: any;
  style?: React.CSSProperties;
  dashed?: boolean;
  innerStyle?: React.CSSProperties;
};

function SelectMenu(
  { children, style, innerStyle, dashed, ...rest }: Props,
  ref: any
) {
  return (
    <Outer
      data-testid="menu-container"
      {...rest}
      style={{
        ...style,
        left: style ? (style as any).left - SHADOW_PADDING : 0,
        width: style ? (style as any).width + SHADOW_PADDING * 2 : 0
      }}
    >
      <SelectMenuBase style={innerStyle} ref={ref} dashed={dashed}>
        {children}
      </SelectMenuBase>
    </Outer>
  );
}

export default React.forwardRef(SelectMenu);
